// item 719 (RNWY Contracts epic S4) — generated contract / onboarding documents.
export enum ContractType {
  Perpetual = 0,
  Subscription = 1,
  SwitchPilot = 2,
  HelpDeskPhda = 3,
  HelpDeskOrder = 4,
  ThirdParty = 5,
  OnboardingGeneral = 6,
  OnboardingHelpDesk = 7,
  // item 1385 — DIRECT END USER channel (Pulse → End User, SwitchPilot only). Both project-level.
  // The SwitchPilot paper carries its EEULA inline (Exhibit B) — signing = accepting, no loop.
  EndUserSwitchPilot = 8,
  EndUserHelpDesk = 9,
  // item 1393 — the rest of the direct set (RNWY platform papers, EEULA inline) + a Third-Party stub
  EndUserPerpetual = 10,
  EndUserSubscription = 11,
  EndUserThirdParty = 12,
}

// item 1385/1393 — one channel per contact: End User contacts paper with these ONLY (menu order)
export const END_USER_CONTRACT_TYPES: ContractType[] = [
  ContractType.EndUserSwitchPilot, ContractType.EndUserSubscription, ContractType.EndUserPerpetual,
  ContractType.EndUserHelpDesk, ContractType.EndUserThirdParty,
];
export const isEndUserContractType = (t: ContractType): boolean => END_USER_CONTRACT_TYPES.includes(t);

export enum ContractStatus {
  Draft = 0,
  Sent = 1,
  CustomerSigned = 2,
  Executed = 3,
  Void = 4,
  Finalized = 5, // item 910 — reviewed + locked; the only state that can be sent
  // item 1123 — Send parks the envelope as a SignWell DRAFT (no emails); only SignWell's own
  // status promotes to Sent (the status sync polls it). "Sent" now means SignWell says sent.
  SignWellDraft = 6,
}

export const CONTRACT_TYPE_LABEL: Record<number, string> = {
  [ContractType.Perpetual]: 'Perpetual Agreement',
  [ContractType.Subscription]: 'Subscription Agreement',
  [ContractType.SwitchPilot]: 'SwitchPilot Agreement',
  [ContractType.HelpDeskPhda]: 'Help Desk — PHDA',
  [ContractType.HelpDeskOrder]: 'Help Desk — Order',
  [ContractType.ThirdParty]: 'Third-Party Agreement',
  [ContractType.OnboardingGeneral]: 'Onboarding — General',
  [ContractType.OnboardingHelpDesk]: 'Onboarding — HelpDesk Terms',
  [ContractType.EndUserSwitchPilot]: 'End User — SwitchPilot Agreement', // item 1385
  [ContractType.EndUserHelpDesk]: 'End User — Help Desk Agreement',
  [ContractType.EndUserPerpetual]: 'End User — Perpetual Agreement', // item 1393
  [ContractType.EndUserSubscription]: 'End User — Subscription Agreement',
  [ContractType.EndUserThirdParty]: 'End User — Third-Party Agreement',
};

// item 978 — quiet internal EEULA state labels (LOUD lives in the portal only)
export const EEULA_STATUS_LABEL: Record<number, string> = {
  0: '', 1: 'EEULA not sent', 2: 'EEULA sent — awaiting', 3: 'EEULA accepted', 4: 'EEULA unknown', 5: 'EEULA attested',
};

export const CONTRACT_STATUS_LABEL: Record<number, string> = {
  [ContractStatus.Draft]: 'DRAFT',
  [ContractStatus.Sent]: 'SIGNWELL SENT', // item 1123 — SENT now means SignWell confirmed it
  [ContractStatus.CustomerSigned]: 'CUSTOMER SIGNED',
  [ContractStatus.Executed]: 'EXECUTED',
  [ContractStatus.Void]: 'VOID',
  [ContractStatus.Finalized]: 'FINALIZED',
  [ContractStatus.SignWellDraft]: 'SIGNWELL DRAFT', // item 1123 — created, not yet sent from SignWell
};

export interface ContractDocumentRow {
  eeulaStatus?: number; // item 978
  eeulaSentToName?: string | null;
  eeulaSentToEmail?: string | null;
  eeulaLastSentAt?: string | null;
  eeulaAcceptedAt?: string | null;
  eeulaAcceptedName?: string | null;
  id: string;
  type: ContractType;
  status: ContractStatus;
  number?: string;
  proposalId?: string | null; // item 1109 — groups a deal's agreements together
  title: string;
  effectiveDate: string;
  createdDate: string;
  storedFileId?: string;
  isVoid: boolean;
}

export interface ContractsDto { index: ContractDocumentRow[]; }
